export const SystemFontsEnum = {
  SYSTEM_UI: 'system-ui',
  MONOSPACE: 'Monospace',
  ARIAL: 'Arial',
  GEORGIA: 'Georgia',
  HELVETICA: 'Helvetica',
  TIMES_NEW_ROMAN: 'Times New Roman',
  COMIC_SANS_MS: 'Comic Sans MS',
  VERDANA: 'Verdana',
  TAHOMA: 'Tahoma',
  IMPACT: 'Impact',
};

export const WebFontsEnum = {
  ABEEZEE: 'ABeeZee',
  ADLAM_DISPLAY: 'ADLaM Display',
  AR_ONE_SANS: 'AR One Sans',
  ABEL: 'Abel',
  ABHAYA_LIBRE: 'Abhaya Libre',
  ABORETO: 'Aboreto',
  ABRIL_FATFACE: 'Abril Fatface',
  ABYSSINICA_SIL: 'Abyssinica SIL',
  ACLONICA: 'Aclonica',
  ACME: 'Acme',
  ACTOR: 'Actor',
  ADAMINA: 'Adamina',
  ADVENT_PRO: 'Advent Pro',
  AGDASIMA: 'Agdasima',
  AGUAFINA_SCRIPT: 'Aguafina Script',
  AKATAB: 'Akatab',
  AKAYA_KANADAKA: 'Akaya Kanadaka',
  AKAYA_TELIVIGALA: 'Akaya Telivigala',
  AKRONIM: 'Akronim',
  AKSHAR: 'Akshar',
  ALADIN: 'Aladin',
  ALATA: 'Alata',
  ALATSI: 'Alatsi',
  ALBERT_SANS: 'Albert Sans',
  ALDRICH: 'Aldrich',
  ALEF: 'Alef',
  ALEGREYA: 'Alegreya',
  ALEGREYA_SC: 'Alegreya SC',
  ALEGREYA_SANS: 'Alegreya Sans',
  ALEGREYA_SANS_SC: 'Alegreya Sans SC',
  ALEO: 'Aleo',
  ALEX_BRUSH: 'Alex Brush',
  ALEXANDRIA: 'Alexandria',
  ALFA_SLAB_ONE: 'Alfa Slab One',
  ALICE: 'Alice',
  ALIKE: 'Alike',
  ALIKE_ANGULAR: 'Alike Angular',
  ALKALAMI: 'Alkalami',
  ALKATRA: 'Alkatra',
  ALLAN: 'Allan',
  ALLERTA: 'Allerta',
  ALLERTA_STENCIL: 'Allerta Stencil',
  ALLISON: 'Allison',
  ALLURA: 'Allura',
  ALMARAI: 'Almarai',
  ALMENDRA: 'Almendra',
  ALMENDRA_DISPLAY: 'Almendra Display',
  ALMENDRA_SC: 'Almendra SC',
  ALUMNI_SANS: 'Alumni Sans',
  ALUMNI_SANS_COLLEGIATE_ONE: 'Alumni Sans Collegiate One',
  ALUMNI_SANS_INLINE_ONE: 'Alumni Sans Inline One',
  ALUMNI_SANS_PINSTRIPE: 'Alumni Sans Pinstripe',
  AMARANTE: 'Amarante',
  AMARANTH: 'Amaranth',
  AMATIC_SC: 'Amatic SC',
  AMETHYSTA: 'Amethysta',
  AMIKO: 'Amiko',
  AMIRI: 'Amiri',
  AMIRI_QURAN: 'Amiri Quran',
  AMITA: 'Amita',
  ANAHEIM: 'Anaheim',
  ANDADA_PRO: 'Andada Pro',
  ANDIKA: 'Andika',
  ANEK_BANGLA: 'Anek Bangla',
  ANEK_DEVANAGARI: 'Anek Devanagari',
  ANEK_GUJARATI: 'Anek Gujarati',
  ANEK_GURMUKHI: 'Anek Gurmukhi',
  ANEK_KANNADA: 'Anek Kannada',
  ANEK_LATIN: 'Anek Latin',
  ANEK_MALAYALAM: 'Anek Malayalam',
  ANEK_ODIA: 'Anek Odia',
  ANEK_TAMIL: 'Anek Tamil',
  ANEK_TELUGU: 'Anek Telugu',
  ANGKOR: 'Angkor',
  ANNIE_USE_YOUR_TELESCOPE: 'Annie Use Your Telescope',
  ANONYMOUS_PRO: 'Anonymous Pro',
  ANTIC: 'Antic',
  ANTIC_DIDONE: 'Antic Didone',
  ANTIC_SLAB: 'Antic Slab',
  ANTON: 'Anton',
  ANTONIO: 'Antonio',
  ANUPHAN: 'Anuphan',
  ANYBODY: 'Anybody',
  AOBOSHI_ONE: 'Aoboshi One',
  ARAPEY: 'Arapey',
  ARBUTUS: 'Arbutus',
  ARBUTUS_SLAB: 'Arbutus Slab',
  ARCHITECTS_DAUGHTER: 'Architects Daughter',
  ARCHIVO: 'Archivo',
  ARCHIVO_BLACK: 'Archivo Black',
  ARCHIVO_NARROW: 'Archivo Narrow',
  ARE_YOU_SERIOUS: 'Are You Serious',
  AREF_RUQAA: 'Aref Ruqaa',
  AREF_RUQAA_INK: 'Aref Ruqaa Ink',
  ARIMA: 'Arima',
  ARIMA_MADURAI: 'Arima Madurai',
  ARIMO: 'Arimo',
  ARIZONIA: 'Arizonia',
  ARMATA: 'Armata',
  ARSENAL: 'Arsenal',
  ARTIFIKA: 'Artifika',
  ARVO: 'Arvo',
  ARYA: 'Arya',
  ASAP: 'Asap',
  ASAP_CONDENSED: 'Asap Condensed',
  ASAR: 'Asar',
  ASSET: 'Asset',
  ASSISTANT: 'Assistant',
  ASTLOCH: 'Astloch',
  ASUL: 'Asul',
  ATHITI: 'Athiti',
  ATKINSON_HYPERLEGIBLE: 'Atkinson Hyperlegible',
  ATMA: 'Atma',
  ATOMIC_AGE: 'Atomic Age',
  AUBREY: 'Aubrey',
  AUDIOWIDE: 'Audiowide',
  AUTOUR_ONE: 'Autour One',
  AVERAGE: 'Average',
  AVERAGE_SANS: 'Average Sans',
  AVERIA_GRUESA_LIBRE: 'Averia Gruesa Libre',
  AVERIA_LIBRE: 'Averia Libre',
  AVERIA_SANS_LIBRE: 'Averia Sans Libre',
  AVERIA_SERIF_LIBRE: 'Averia Serif Libre',
  AZERET_MONO: 'Azeret Mono',
  B612: 'B612',
  B612_MONO: 'B612 Mono',
  BIZ_UDGOTHIC: 'BIZ UDGothic',
  BIZ_UDMINCHO: 'BIZ UDMincho',
  BIZ_UDPGOTHIC: 'BIZ UDPGothic',
  BIZ_UDPMINCHO: 'BIZ UDPMincho',
  BABYLONICA: 'Babylonica',
  BACASIME_ANTIQUE: 'Bacasime Antique',
  BAD_SCRIPT: 'Bad Script',
  BAGEL_FAT_ONE: 'Bagel Fat One',
  BAHIANA: 'Bahiana',
  BAHIANITA: 'Bahianita',
  BAI_JAMJUREE: 'Bai Jamjuree',
  BAKBAK_ONE: 'Bakbak One',
  BALLET: 'Ballet',
  BALOO_2: 'Baloo 2',
  BALOO_BHAI_2: 'Baloo Bhai 2',
  BALOO_BHAIJAAN_2: 'Baloo Bhaijaan 2',
  BALOO_BHAINA_2: 'Baloo Bhaina 2',
  BALOO_CHETTAN_2: 'Baloo Chettan 2',
  BALOO_DA_2: 'Baloo Da 2',
  BALOO_PAAJI_2: 'Baloo Paaji 2',
  BALOO_TAMMA_2: 'Baloo Tamma 2',
  BALOO_TAMMUDU_2: 'Baloo Tammudu 2',
  BALOO_THAMBI_2: 'Baloo Thambi 2',
  BALSAMIQ_SANS: 'Balsamiq Sans',
  BALTHAZAR: 'Balthazar',
  BANGERS: 'Bangers',
  BARLOW: 'Barlow',
  BARLOW_CONDENSED: 'Barlow Condensed',
  BARLOW_SEMI_CONDENSED: 'Barlow Semi Condensed',
  BARRIECITO: 'Barriecito',
  BARRIO: 'Barrio',
  BASIC: 'Basic',
  BASKERVVILLE: 'Baskervville',
  BATTAMBANG: 'Battambang',
  BAUMANS: 'Baumans',
  BAYON: 'Bayon',
  BE_VIETNAM_PRO: 'Be Vietnam Pro',
  BEAU_RIVAGE: 'Beau Rivage',
  BEBAS_NEUE: 'Bebas Neue',
  BELANOSIMA: 'Belanosima',
  BELGRANO: 'Belgrano',
  BELLEFAIR: 'Bellefair',
  BELLEZA: 'Belleza',
  BELLOTA: 'Bellota',
  BELLOTA_TEXT: 'Bellota Text',
  BENCHNINE: 'BenchNine',
  BENNE: 'Benne',
  BENTHAM: 'Bentham',
  BERKSHIRE_SWASH: 'Berkshire Swash',
  BESLEY: 'Besley',
  BETH_ELLEN: 'Beth Ellen',
  BEVAN: 'Bevan',
  BHUTUKA_EXPANDED_ONE: 'BhuTuka Expanded One',
  BIG_SHOULDERS_DISPLAY: 'Big Shoulders Display',
  BIG_SHOULDERS_INLINE_DISPLAY: 'Big Shoulders Inline Display',
  BIG_SHOULDERS_INLINE_TEXT: 'Big Shoulders Inline Text',
  BIG_SHOULDERS_STENCIL_DISPLAY: 'Big Shoulders Stencil Display',
  BIG_SHOULDERS_STENCIL_TEXT: 'Big Shoulders Stencil Text',
  BIG_SHOULDERS_TEXT: 'Big Shoulders Text',
  BIGELOW_RULES: 'Bigelow Rules',
  BIGSHOT_ONE: 'Bigshot One',
  BILBO: 'Bilbo',
  BILBO_SWASH_CAPS: 'Bilbo Swash Caps',
  BIORHYME: 'BioRhyme',
  BIORHYME_EXPANDED: 'BioRhyme Expanded',
  BIRTHSTONE: 'Birthstone',
  BIRTHSTONE_BOUNCE: 'Birthstone Bounce',
  BIRYANI: 'Biryani',
  BITTER: 'Bitter',
  BLACK_AND_WHITE_PICTURE: 'Black And White Picture',
  BLACK_HAN_SANS: 'Black Han Sans',
  BLACK_OPS_ONE: 'Black Ops One',
  BLAKA: 'Blaka',
  BLAKA_HOLLOW: 'Blaka Hollow',
  BLAKA_INK: 'Blaka Ink',
  BLINKER: 'Blinker',
  BODONI_MODA: 'Bodoni Moda',
  BOKOR: 'Bokor',
  BONA_NOVA: 'Bona Nova',
  BONBON: 'Bonbon',
  BONHEUR_ROYALE: 'Bonheur Royale',
  BOOGALOO: 'Boogaloo',
  BOREL: 'Borel',
  BOWLBY_ONE: 'Bowlby One',
  BOWLBY_ONE_SC: 'Bowlby One SC',
  BRAAH_ONE: 'Braah One',
  BRAWLER: 'Brawler',
  BREE_SERIF: 'Bree Serif',
  BRICOLAGE_GROTESQUE: 'Bricolage Grotesque',
  BRUNO_ACE: 'Bruno Ace',
  BRUNO_ACE_SC: 'Bruno Ace SC',
  BRYGADA_1918: 'Brygada 1918',
  BUBBLEGUM_SANS: 'Bubblegum Sans',
  BUBBLER_ONE: 'Bubbler One',
  BUDA: 'Buda',
  BUENARD: 'Buenard',
  BUNGEE: 'Bungee',
  BUNGEE_HAIRLINE: 'Bungee Hairline',
  BUNGEE_INLINE: 'Bungee Inline',
  BUNGEE_OUTLINE: 'Bungee Outline',
  BUNGEE_SHADE: 'Bungee Shade',
  BUNGEE_SPICE: 'Bungee Spice',
  BUTCHERMAN: 'Butcherman',
  BUTTERFLY_KIDS: 'Butterfly Kids',
  CABIN: 'Cabin',
  CABIN_CONDENSED: 'Cabin Condensed',
  CABIN_SKETCH: 'Cabin Sketch',
  CAESAR_DRESSING: 'Caesar Dressing',
  CAGLIOSTRO: 'Cagliostro',
  CAIRO: 'Cairo',
  CAIRO_PLAY: 'Cairo Play',
  CALADEA: 'Caladea',
  CALISTOGA: 'Calistoga',
  CALLIGRAFFITTI: 'Calligraffitti',
  CAMBAY: 'Cambay',
  CAMBO: 'Cambo',
  CANDAL: 'Candal',
  CANTARELL: 'Cantarell',
  CANTATA_ONE: 'Cantata One',
  CANTORA_ONE: 'Cantora One',
  CAPRASIMO: 'Caprasimo',
  CAPRIOLA: 'Capriola',
  CARAMEL: 'Caramel',
  CARATTERE: 'Carattere',
  CARDO: 'Cardo',
  CARLITO: 'Carlito',
  CARME: 'Carme',
  CARROIS_GOTHIC: 'Carrois Gothic',
  CARROIS_GOTHIC_SC: 'Carrois Gothic SC',
  CARTER_ONE: 'Carter One',
  CASTORO: 'Castoro',
  CASTORO_TITLING: 'Castoro Titling',
  CATAMARAN: 'Catamaran',
  CAUDEX: 'Caudex',
  CAVEAT: 'Caveat',
  CAVEAT_BRUSH: 'Caveat Brush',
  CEDARVILLE_CURSIVE: 'Cedarville Cursive',
  CEVICHE_ONE: 'Ceviche One',
  CHAKRA_PETCH: 'Chakra Petch',
  CHANGA: 'Changa',
  CHANGA_ONE: 'Changa One',
  CHANGO: 'Chango',
  CHARIS_SIL: 'Charis SIL',
  CHARM: 'Charm',
  CHARMONMAN: 'Charmonman',
  CHATHURA: 'Chathura',
  CHAU_PHILOMENE_ONE: 'Chau Philomene One',
  CHELA_ONE: 'Chela One',
  CHELSEA_MARKET: 'Chelsea Market',
  CHENLA: 'Chenla',
  CHERISH: 'Cherish',
  CHERRY_BOMB_ONE: 'Cherry Bomb One',
  CHERRY_CREAM_SODA: 'Cherry Cream Soda',
  CHERRY_SWASH: 'Cherry Swash',
  CHEWY: 'Chewy',
  CHICLE: 'Chicle',
  CHILANKA: 'Chilanka',
  CHIVO: 'Chivo',
  CHIVO_MONO: 'Chivo Mono',
  CHOKOKUTAI: 'Chokokutai',
  CHONBURI: 'Chonburi',
  CINZEL: 'Cinzel',
  CINZEL_DECORATIVE: 'Cinzel Decorative',
  CLICKER_SCRIPT: 'Clicker Script',
  CLIMATE_CRISIS: 'Climate Crisis',
  CODA: 'Coda',
  CODA_CAPTION: 'Coda Caption',
  CODYSTAR: 'Codystar',
  COINY: 'Coiny',
  COMBO: 'Combo',
  COMFORTAA: 'Comfortaa',
  COMFORTER: 'Comforter',
  COMFORTER_BRUSH: 'Comforter Brush',
  COMIC_NEUE: 'Comic Neue',
  COMING_SOON: 'Coming Soon',
  COMME: 'Comme',
  COMMISSIONER: 'Commissioner',
  CONCERT_ONE: 'Concert One',
  CONDIMENT: 'Condiment',
  CONTENT: 'Content',
  CONTRAIL_ONE: 'Contrail One',
  CONVERGENCE: 'Convergence',
  COOKIE: 'Cookie',
  COPSE: 'Copse',
  CORBEN: 'Corben',
  CORINTHIA: 'Corinthia',
  CORMORANT: 'Cormorant',
  CORMORANT_GARAMOND: 'Cormorant Garamond',
  CORMORANT_INFANT: 'Cormorant Infant',
  CORMORANT_SC: 'Cormorant SC',
  CORMORANT_UNICASE: 'Cormorant Unicase',
  CORMORANT_UPRIGHT: 'Cormorant Upright',
  COURGETTE: 'Courgette',
  COURIER_PRIME: 'Courier Prime',
  COUSINE: 'Cousine',
  COUSTARD: 'Coustard',
  COVERED_BY_YOUR_GRACE: 'Covered By Your Grace',
  CRAFTY_GIRLS: 'Crafty Girls',
  CREEPSTER: 'Creepster',
  CRETE_ROUND: 'Crete Round',
  CRIMSON_PRO: 'Crimson Pro',
  CRIMSON_TEXT: 'Crimson Text',
  CROISSANT_ONE: 'Croissant One',
  CRUSHED: 'Crushed',
  CUPRUM: 'Cuprum',
  CUTE_FONT: 'Cute Font',
  CUTIVE: 'Cutive',
  CUTIVE_MONO: 'Cutive Mono',
  DM_MONO: 'DM Mono',
  DM_SANS: 'DM Sans',
  DM_SERIF_DISPLAY: 'DM Serif Display',
  DM_SERIF_TEXT: 'DM Serif Text',
  DAI_BANNA_SIL: 'Dai Banna SIL',
  DAMION: 'Damion',
  DANCING_SCRIPT: 'Dancing Script',
  DANGREK: 'Dangrek',
  DARKER_GROTESQUE: 'Darker Grotesque',
  DARUMADROP_ONE: 'Darumadrop One',
  DAVID_LIBRE: 'David Libre',
  DAWNING_OF_A_NEW_DAY: 'Dawning of a New Day',
  DAYS_ONE: 'Days One',
  DEKKO: 'Dekko',
  DELA_GOTHIC_ONE: 'Dela Gothic One',
  DELICIOUS_HANDRAWN: 'Delicious Handrawn',
  DELIUS: 'Delius',
  DELIUS_SWASH_CAPS: 'Delius Swash Caps',
  DELIUS_UNICASE: 'Delius Unicase',
  DELLA_RESPIRA: 'Della Respira',
  DENK_ONE: 'Denk One',
  DEVONSHIRE: 'Devonshire',
  DHURJATI: 'Dhurjati',
  DIDACT_GOTHIC: 'Didact Gothic',
  DIPHYLLEIA: 'Diphylleia',
  DIPLOMATA: 'Diplomata',
  DIPLOMATA_SC: 'Diplomata SC',
  DO_HYEON: 'Do Hyeon',
  DOKDO: 'Dokdo',
  DOMINE: 'Domine',
  DONEGAL_ONE: 'Donegal One',
  DONGLE: 'Dongle',
  DOPPIO_ONE: 'Doppio One',
  DORSA: 'Dorsa',
  DOSIS: 'Dosis',
  DOTGOTHIC16: 'DotGothic16',
  DR_SUGIYAMA: 'Dr Sugiyama',
  DURU_SANS: 'Duru Sans',
  DYNAPUFF: 'DynaPuff',
  DYNALIGHT: 'Dynalight',
  EB_GARAMOND: 'EB Garamond',
  EAGLE_LAKE: 'Eagle Lake',
  EAST_SEA_DOKDO: 'East Sea Dokdo',
  EATER: 'Eater',
  ECONOMICA: 'Economica',
  ECZAR: 'Eczar',
  EDU_NSW_ACT_FOUNDATION: 'Edu NSW ACT Foundation',
  EDU_QLD_BEGINNER: 'Edu QLD Beginner',
  EDU_SA_BEGINNER: 'Edu SA Beginner',
  EDU_TAS_BEGINNER: 'Edu TAS Beginner',
  EDU_VIC_WA_NT_BEGINNER: 'Edu VIC WA NT Beginner',
  EL_MESSIRI: 'El Messiri',
  ELECTROLIZE: 'Electrolize',
  ELSIE: 'Elsie',
  ELSIE_SWASH_CAPS: 'Elsie Swash Caps',
  EMBLEMA_ONE: 'Emblema One',
  EMILYS_CANDY: 'Emilys Candy',
  ENCODE_SANS: 'Encode Sans',
  ENCODE_SANS_CONDENSED: 'Encode Sans Condensed',
  ENCODE_SANS_EXPANDED: 'Encode Sans Expanded',
  ENCODE_SANS_SC: 'Encode Sans SC',
  ENCODE_SANS_SEMI_CONDENSED: 'Encode Sans Semi Condensed',
  ENCODE_SANS_SEMI_EXPANDED: 'Encode Sans Semi Expanded',
  ENGAGEMENT: 'Engagement',
  ENGLEBERT: 'Englebert',
  ENRIQUETA: 'Enriqueta',
  EPHESIS: 'Ephesis',
  EPILOGUE: 'Epilogue',
  ERICA_ONE: 'Erica One',
  ESTEBAN: 'Esteban',
  ESTONIA: 'Estonia',
  EUPHORIA_SCRIPT: 'Euphoria Script',
  EWERT: 'Ewert',
  EXO: 'Exo',
  EXO_2: 'Exo 2',
  EXPLETUS_SANS: 'Expletus Sans',
  EXPLORA: 'Explora',
  FAHKWANG: 'Fahkwang',
  FAMILJEN_GROTESK: 'Familjen Grotesk',
  FANWOOD_TEXT: 'Fanwood Text',
  FARRO: 'Farro',
  FARSAN: 'Farsan',
  FASCINATE: 'Fascinate',
  FASCINATE_INLINE: 'Fascinate Inline',
  FASTER_ONE: 'Faster One',
  FASTHAND: 'Fasthand',
  FAUNA_ONE: 'Fauna One',
  FAUSTINA: 'Faustina',
  FEDERANT: 'Federant',
  FEDERO: 'Federo',
  FELIPA: 'Felipa',
  FENIX: 'Fenix',
  FESTIVE: 'Festive',
  FIGTREE: 'Figtree',
  FINGER_PAINT: 'Finger Paint',
  FINLANDICA: 'Finlandica',
  FIRA_CODE: 'Fira Code',
  FIRA_MONO: 'Fira Mono',
  FIRA_SANS: 'Fira Sans',
  FIRA_SANS_CONDENSED: 'Fira Sans Condensed',
  FIRA_SANS_EXTRA_CONDENSED: 'Fira Sans Extra Condensed',
  FJALLA_ONE: 'Fjalla One',
  FJORD_ONE: 'Fjord One',
  FLAMENCO: 'Flamenco',
  FLAVORS: 'Flavors',
  FLEUR_DE_LEAH: 'Fleur De Leah',
  FLOW_BLOCK: 'Flow Block',
  FLOW_CIRCULAR: 'Flow Circular',
  FLOW_ROUNDED: 'Flow Rounded',
  FOLDIT: 'Foldit',
  FONDAMENTO: 'Fondamento',
  FONTDINER_SWANKY: 'Fontdiner Swanky',
  FORUM: 'Forum',
  FRAGMENT_MONO: 'Fragment Mono',
  FRANCOIS_ONE: 'Francois One',
  FRANK_RUHL_LIBRE: 'Frank Ruhl Libre',
  FRAUNCES: 'Fraunces',
  FRECKLE_FACE: 'Freckle Face',
  FREDERICKA_THE_GREAT: 'Fredericka the Great',
  FREDOKA: 'Fredoka',
  FREEHAND: 'Freehand',
  FRESCA: 'Fresca',
  FRIJOLE: 'Frijole',
  FRUKTUR: 'Fruktur',
  FUGAZ_ONE: 'Fugaz One',
  FUGGLES: 'Fuggles',
  FUZZY_BUBBLES: 'Fuzzy Bubbles',
  GFS_DIDOT: 'GFS Didot',
  GFS_NEOHELLENIC: 'GFS Neohellenic',
  GABARITO: 'Gabarito',
  GABRIELA: 'Gabriela',
  GAEGU: 'Gaegu',
  GAFATA: 'Gafata',
  GAJRAJ_ONE: 'Gajraj One',
  GALADA: 'Galada',
  GALDEANO: 'Galdeano',
  GALINDO: 'Galindo',
  GAMJA_FLOWER: 'Gamja Flower',
  GANTARI: 'Gantari',
  GASOEK_ONE: 'Gasoek One',
  GAYATHRI: 'Gayathri',
  GELASIO: 'Gelasio',
  GEMUNU_LIBRE: 'Gemunu Libre',
  GENOS: 'Genos',
  GENTIUM_BOOK_PLUS: 'Gentium Book Plus',
  GENTIUM_PLUS: 'Gentium Plus',
  GEO: 'Geo',
  GEOLOGICA: 'Geologica',
  GEORAMA: 'Georama',
  GEOSTAR: 'Geostar',
  GEOSTAR_FILL: 'Geostar Fill',
  GERMANIA_ONE: 'Germania One',
  GIDEON_ROMAN: 'Gideon Roman',
  GIDUGU: 'Gidugu',
  GILDA_DISPLAY: 'Gilda Display',
  GIRASSOL: 'Girassol',
  GIVE_YOU_GLORY: 'Give You Glory',
  GLASS_ANTIQUA: 'Glass Antiqua',
  GLEGOO: 'Glegoo',
  GLOOCK: 'Gloock',
  GLORIA_HALLELUJAH: 'Gloria Hallelujah',
  GLORY: 'Glory',
  GLUTEN: 'Gluten',
  GOBLIN_ONE: 'Goblin One',
  GOCHI_HAND: 'Gochi Hand',
  GOLDMAN: 'Goldman',
  GOLOS_TEXT: 'Golos Text',
  GORDITAS: 'Gorditas',
  GOTHIC_A1: 'Gothic A1',
  GOTU: 'Gotu',
  GOUDY_BOOKLETTER_1911: 'Goudy Bookletter 1911',
  GOWUN_BATANG: 'Gowun Batang',
  GOWUN_DODUM: 'Gowun Dodum',
  GRADUATE: 'Graduate',
  GRAND_HOTEL: 'Grand Hotel',
  GRANDIFLORA_ONE: 'Grandiflora One',
  GRANDSTANDER: 'Grandstander',
  GRAPE_NUTS: 'Grape Nuts',
  GRAVITAS_ONE: 'Gravitas One',
  GREAT_VIBES: 'Great Vibes',
  GRECHEN_FUEMEN: 'Grechen Fuemen',
  GRENZE: 'Grenze',
  GRENZE_GOTISCH: 'Grenze Gotisch',
  GREY_QO: 'Grey Qo',
  GRIFFY: 'Griffy',
  GRUPPO: 'Gruppo',
  GUDEA: 'Gudea',
  GUGI: 'Gugi',
  GULZAR: 'Gulzar',
  GUPTER: 'Gupter',
  GURAJADA: 'Gurajada',
  GWENDOLYN: 'Gwendolyn',
  HABIBI: 'Habibi',
  HACHI_MARU_POP: 'Hachi Maru Pop',
  HAHMLET: 'Hahmlet',
  HALANT: 'Halant',
  HAMMERSMITH_ONE: 'Hammersmith One',
  HANALEI: 'Hanalei',
  HANALEI_FILL: 'Hanalei Fill',
  HANDJET: 'Handjet',
  HANDLEE: 'Handlee',
  HANKEN_GROTESK: 'Hanken Grotesk',
  HANUMAN: 'Hanuman',
  HAPPY_MONKEY: 'Happy Monkey',
  HARMATTAN: 'Harmattan',
  HEADLAND_ONE: 'Headland One',
  HEEBO: 'Heebo',
  HENNY_PENNY: 'Henny Penny',
  HEPTA_SLAB: 'Hepta Slab',
  HERR_VON_MUELLERHOFF: 'Herr Von Muellerhoff',
  HI_MELODY: 'Hi Melody',
  HINA_MINCHO: 'Hina Mincho',
  HIND: 'Hind',
  HIND_GUNTUR: 'Hind Guntur',
  HIND_MADURAI: 'Hind Madurai',
  HIND_SILIGURI: 'Hind Siliguri',
  HIND_VADODARA: 'Hind Vadodara',
  HOLTWOOD_ONE_SC: 'Holtwood One SC',
  HOMEMADE_APPLE: 'Homemade Apple',
  HOMENAJE: 'Homenaje',
  HUBBALLI: 'Hubballi',
  HURRICANE: 'Hurricane',
  IBM_PLEX_MONO: 'IBM Plex Mono',
  IBM_PLEX_SANS: 'IBM Plex Sans',
  IBM_PLEX_SANS_ARABIC: 'IBM Plex Sans Arabic',
  IBM_PLEX_SANS_CONDENSED: 'IBM Plex Sans Condensed',
  IBM_PLEX_SANS_DEVANAGARI: 'IBM Plex Sans Devanagari',
  IBM_PLEX_SANS_HEBREW: 'IBM Plex Sans Hebrew',
  IBM_PLEX_SANS_JP: 'IBM Plex Sans JP',
  IBM_PLEX_SANS_KR: 'IBM Plex Sans KR',
  IBM_PLEX_SANS_THAI: 'IBM Plex Sans Thai',
  IBM_PLEX_SANS_THAI_LOOPED: 'IBM Plex Sans Thai Looped',
  IBM_PLEX_SERIF: 'IBM Plex Serif',
  IM_FELL_DW_PICA: 'IM Fell DW Pica',
  IM_FELL_DW_PICA_SC: 'IM Fell DW Pica SC',
  IM_FELL_DOUBLE_PICA: 'IM Fell Double Pica',
  IM_FELL_DOUBLE_PICA_SC: 'IM Fell Double Pica SC',
  IM_FELL_ENGLISH: 'IM Fell English',
  IM_FELL_ENGLISH_SC: 'IM Fell English SC',
  IM_FELL_FRENCH_CANON: 'IM Fell French Canon',
  IM_FELL_FRENCH_CANON_SC: 'IM Fell French Canon SC',
  IM_FELL_GREAT_PRIMER: 'IM Fell Great Primer',
  IM_FELL_GREAT_PRIMER_SC: 'IM Fell Great Primer SC',
  IBARRA_REAL_NOVA: 'Ibarra Real Nova',
  ICEBERG: 'Iceberg',
  ICELAND: 'Iceland',
  IMBUE: 'Imbue',
  IMPERIAL_SCRIPT: 'Imperial Script',
  IMPRIMA: 'Imprima',
  INCLUSIVE_SANS: 'Inclusive Sans',
  INCONSOLATA: 'Inconsolata',
  INDER: 'Inder',
  INDIE_FLOWER: 'Indie Flower',
  INGRID_DARLING: 'Ingrid Darling',
  INIKA: 'Inika',
  INKNUT_ANTIQUA: 'Inknut Antiqua',
  INRIA_SANS: 'Inria Sans',
  INRIA_SERIF: 'Inria Serif',
  INSPIRATION: 'Inspiration',
  INSTRUMENT_SANS: 'Instrument Sans',
  INSTRUMENT_SERIF: 'Instrument Serif',
  INTER: 'Inter',
  INTER_TIGHT: 'Inter Tight',
  IRISH_GROVER: 'Irish Grover',
  ISLAND_MOMENTS: 'Island Moments',
  ISTOK_WEB: 'Istok Web',
  ITALIANA: 'Italiana',
  ITALIANNO: 'Italianno',
  ITIM: 'Itim',
  JACQUES_FRANCOIS: 'Jacques Francois',
  JACQUES_FRANCOIS_SHADOW: 'Jacques Francois Shadow',
  JALDI: 'Jaldi',
  JETBRAINS_MONO: 'JetBrains Mono',
  JIM_NIGHTSHADE: 'Jim Nightshade',
  JOAN: 'Joan',
  JOCKEY_ONE: 'Jockey One',
  JOLLY_LODGER: 'Jolly Lodger',
  JOMHURIA: 'Jomhuria',
  JOMOLHARI: 'Jomolhari',
  JOSEFIN_SANS: 'Josefin Sans',
  JOSEFIN_SLAB: 'Josefin Slab',
  JOST: 'Jost',
  JOTI_ONE: 'Joti One',
  JUA: 'Jua',
  JUDSON: 'Judson',
  JULEE: 'Julee',
  JULIUS_SANS_ONE: 'Julius Sans One',
  JUNGE: 'Junge',
  JURA: 'Jura',
  JUST_ANOTHER_HAND: 'Just Another Hand',
  JUST_ME_AGAIN_DOWN_HERE: 'Just Me Again Down Here',
  K2D: 'K2D',
  KABLAMMO: 'Kablammo',
  KADWA: 'Kadwa',
  KAISEI_DECOL: 'Kaisei Decol',
  KAISEI_HARUNOUMI: 'Kaisei HarunoUmi',
  KAISEI_OPTI: 'Kaisei Opti',
  KAISEI_TOKUMIN: 'Kaisei Tokumin',
  KALAM: 'Kalam',
  KAMERON: 'Kameron',
  KANIT: 'Kanit',
  KANTUMRUY_PRO: 'Kantumruy Pro',
  KARANTINA: 'Karantina',
  KARLA: 'Karla',
  KARMA: 'Karma',
  KATIBEH: 'Katibeh',
  KAUSHAN_SCRIPT: 'Kaushan Script',
  KAVIVANAR: 'Kavivanar',
  KAVOON: 'Kavoon',
  KDAM_THMOR_PRO: 'Kdam Thmor Pro',
  KEANIA_ONE: 'Keania One',
  KELLY_SLAB: 'Kelly Slab',
  KENIA: 'Kenia',
  KHAND: 'Khand',
  KHMER: 'Khmer',
  KHULA: 'Khula',
  KINGS: 'Kings',
  KIRANG_HAERANG: 'Kirang Haerang',
  KITE_ONE: 'Kite One',
  KIWI_MARU: 'Kiwi Maru',
  KLEE_ONE: 'Klee One',
  KNEWAVE: 'Knewave',
  KOHO: 'KoHo',
  KODCHASAN: 'Kodchasan',
  KOH_SANTEPHEAP: 'Koh Santepheap',
  KOLKER_BRUSH: 'Kolker Brush',
  KONKHMER_SLEOKCHHER: 'Konkhmer Sleokchher',
  KOSUGI: 'Kosugi',
  KOSUGI_MARU: 'Kosugi Maru',
  KOTTA_ONE: 'Kotta One',
  KOULEN: 'Koulen',
  KRANKY: 'Kranky',
  KREON: 'Kreon',
  KRISTI: 'Kristi',
  KRONA_ONE: 'Krona One',
  KRUB: 'Krub',
  KUFAM: 'Kufam',
  KULIM_PARK: 'Kulim Park',
  KUMAR_ONE: 'Kumar One',
  KUMAR_ONE_OUTLINE: 'Kumar One Outline',
  KUMBH_SANS: 'Kumbh Sans',
  KURALE: 'Kurale',
  LA_BELLE_AURORE: 'La Belle Aurore',
  LABRADA: 'Labrada',
  LACQUER: 'Lacquer',
  LAILA: 'Laila',
  LAKKI_REDDY: 'Lakki Reddy',
  LALEZAR: 'Lalezar',
  LANCELOT: 'Lancelot',
  LANGAR: 'Langar',
  LATEEF: 'Lateef',
  LATO: 'Lato',
  LAVISHLY_YOURS: 'Lavishly Yours',
  LEAGUE_GOTHIC: 'League Gothic',
  LEAGUE_SCRIPT: 'League Script',
  LEAGUE_SPARTAN: 'League Spartan',
  LECKERLI_ONE: 'Leckerli One',
  LEDGER: 'Ledger',
  LEKTON: 'Lekton',
  LEMON: 'Lemon',
  LEMONADA: 'Lemonada',
  LEXEND: 'Lexend',
  LEXEND_DECA: 'Lexend Deca',
  LEXEND_EXA: 'Lexend Exa',
  LEXEND_GIGA: 'Lexend Giga',
  LEXEND_MEGA: 'Lexend Mega',
  LEXEND_PETA: 'Lexend Peta',
  LEXEND_TERA: 'Lexend Tera',
  LEXEND_ZETTA: 'Lexend Zetta',
  LIBRE_BARCODE_128: 'Libre Barcode 128',
  LIBRE_BARCODE_128_TEXT: 'Libre Barcode 128 Text',
  LIBRE_BARCODE_39: 'Libre Barcode 39',
  LIBRE_BARCODE_39_EXTENDED: 'Libre Barcode 39 Extended',
  LIBRE_BARCODE_39_EXTENDED_TEXT: 'Libre Barcode 39 Extended Text',
  LIBRE_BARCODE_39_TEXT: 'Libre Barcode 39 Text',
  LIBRE_BARCODE_EAN13_TEXT: 'Libre Barcode EAN13 Text',
  LIBRE_BASKERVILLE: 'Libre Baskerville',
  LIBRE_BODONI: 'Libre Bodoni',
  LIBRE_CASLON_DISPLAY: 'Libre Caslon Display',
  LIBRE_CASLON_TEXT: 'Libre Caslon Text',
  LIBRE_FRANKLIN: 'Libre Franklin',
  LICORICE: 'Licorice',
  LIFE_SAVERS: 'Life Savers',
  LILITA_ONE: 'Lilita One',
  LILY_SCRIPT_ONE: 'Lily Script One',
  LIMELIGHT: 'Limelight',
  LINDEN_HILL: 'Linden Hill',
  LISU_BOSA: 'Lisu Bosa',
  LITERATA: 'Literata',
  LIU_JIAN_MAO_CAO: 'Liu Jian Mao Cao',
  LIVVIC: 'Livvic',
  LOBSTER: 'Lobster',
  LOBSTER_TWO: 'Lobster Two',
  LONDRINA_OUTLINE: 'Londrina Outline',
  LONDRINA_SHADOW: 'Londrina Shadow',
  LONDRINA_SKETCH: 'Londrina Sketch',
  LONDRINA_SOLID: 'Londrina Solid',
  LONG_CANG: 'Long Cang',
  LORA: 'Lora',
  LOVE_LIGHT: 'Love Light',
  LOVE_YA_LIKE_A_SISTER: 'Love Ya Like A Sister',
  LOVED_BY_THE_KING: 'Loved by the King',
  LOVERS_QUARREL: 'Lovers Quarrel',
  LUCKIEST_GUY: 'Luckiest Guy',
  LUGRASIMO: 'Lugrasimo',
  LUMANOSIMO: 'Lumanosimo',
  LUNASIMA: 'Lunasima',
  LUSITANA: 'Lusitana',
  LUSTRIA: 'Lustria',
  LUXURIOUS_ROMAN: 'Luxurious Roman',
  LUXURIOUS_SCRIPT: 'Luxurious Script',
  M_PLUS_1: 'M PLUS 1',
  M_PLUS_1_CODE: 'M PLUS 1 Code',
  M_PLUS_1P: 'M PLUS 1p',
  M_PLUS_2: 'M PLUS 2',
  M_PLUS_CODE_LATIN: 'M PLUS Code Latin',
  M_PLUS_ROUNDED_1C: 'M PLUS Rounded 1c',
  MA_SHAN_ZHENG: 'Ma Shan Zheng',
  MACONDO: 'Macondo',
  MACONDO_SWASH_CAPS: 'Macondo Swash Caps',
  MADA: 'Mada',
  MAGRA: 'Magra',
  MAIDEN_ORANGE: 'Maiden Orange',
  MAITREE: 'Maitree',
  MAJOR_MONO_DISPLAY: 'Major Mono Display',
  MAKO: 'Mako',
  MALI: 'Mali',
  MALLANNA: 'Mallanna',
  MANDALI: 'Mandali',
  MANJARI: 'Manjari',
  MANROPE: 'Manrope',
  MANSALVA: 'Mansalva',
  MANUALE: 'Manuale',
  MARCELLUS: 'Marcellus',
  MARCELLUS_SC: 'Marcellus SC',
  MARCK_SCRIPT: 'Marck Script',
  MARGARINE: 'Margarine',
  MARHEY: 'Marhey',
  MARKAZI_TEXT: 'Markazi Text',
  MARKO_ONE: 'Marko One',
  MARMELAD: 'Marmelad',
  MARTEL: 'Martel',
  MARTEL_SANS: 'Martel Sans',
  MARTIAN_MONO: 'Martian Mono',
  MARVEL: 'Marvel',
  MATE: 'Mate',
  MATE_SC: 'Mate SC',
  MATERIAL_ICONS: 'Material Icons',
  MATERIAL_ICONS_OUTLINED: 'Material Icons Outlined',
  MATERIAL_ICONS_ROUND: 'Material Icons Round',
  MATERIAL_ICONS_SHARP: 'Material Icons Sharp',
  MATERIAL_ICONS_TWO_TONE: 'Material Icons Two Tone',
  MATERIAL_SYMBOLS_OUTLINED: 'Material Symbols Outlined',
  MATERIAL_SYMBOLS_ROUNDED: 'Material Symbols Rounded',
  MATERIAL_SYMBOLS_SHARP: 'Material Symbols Sharp',
  MAVEN_PRO: 'Maven Pro',
  MCLAREN: 'McLaren',
  MEA_CULPA: 'Mea Culpa',
  MEDDON: 'Meddon',
  MEDIEVALSHARP: 'MedievalSharp',
  MEDULA_ONE: 'Medula One',
  MEERA_INIMAI: 'Meera Inimai',
  MEGRIM: 'Megrim',
  MEIE_SCRIPT: 'Meie Script',
  MEOW_SCRIPT: 'Meow Script',
  MERIENDA: 'Merienda',
  MERRIWEATHER: 'Merriweather',
  MERRIWEATHER_SANS: 'Merriweather Sans',
  METAL: 'Metal',
  METAL_MANIA: 'Metal Mania',
  METAMORPHOUS: 'Metamorphous',
  METROPHOBIC: 'Metrophobic',
  MICHROMA: 'Michroma',
  MILONGA: 'Milonga',
  MILTONIAN: 'Miltonian',
  MILTONIAN_TATTOO: 'Miltonian Tattoo',
  MINA: 'Mina',
  MINGZAT: 'Mingzat',
  MINIVER: 'Miniver',
  MIRIAM_LIBRE: 'Miriam Libre',
  MIRZA: 'Mirza',
  MISS_FAJARDOSE: 'Miss Fajardose',
  MITR: 'Mitr',
  MOCHIY_POP_ONE: 'Mochiy Pop One',
  MOCHIY_POP_P_ONE: 'Mochiy Pop P One',
  MODAK: 'Modak',
  MODERN_ANTIQUA: 'Modern Antiqua',
  MOGRA: 'Mogra',
  MOHAVE: 'Mohave',
  MOIRAI_ONE: 'Moirai One',
  MOLENGO: 'Molengo',
  MOLLE: 'Molle',
  MONDA: 'Monda',
  MONOFETT: 'Monofett',
  MONOMANIAC_ONE: 'Monomaniac One',
  MONOTON: 'Monoton',
  MONSIEUR_LA_DOULAISE: 'Monsieur La Doulaise',
  MONTAGA: 'Montaga',
  MONTAGU_SLAB: 'Montagu Slab',
  MONTECARLO: 'MonteCarlo',
  MONTEZ: 'Montez',
  MONTSERRAT: 'Montserrat',
  MONTSERRAT_ALTERNATES: 'Montserrat Alternates',
  MONTSERRAT_SUBRAYADA: 'Montserrat Subrayada',
  MOO_LAH_LAH: 'Moo Lah Lah',
  MOOLI: 'Mooli',
  MOON_DANCE: 'Moon Dance',
  MOUL: 'Moul',
  MOULPALI: 'Moulpali',
  MOUNTAINS_OF_CHRISTMAS: 'Mountains of Christmas',
  MOUSE_MEMOIRS: 'Mouse Memoirs',
  MR_BEDFORT: 'Mr Bedfort',
  MR_DAFOE: 'Mr Dafoe',
  MR_DE_HAVILAND: 'Mr De Haviland',
  MRS_SAINT_DELAFIELD: 'Mrs Saint Delafield',
  MRS_SHEPPARDS: 'Mrs Sheppards',
  MS_MADI: 'Ms Madi',
  MUKTA: 'Mukta',
  MUKTA_MAHEE: 'Mukta Mahee',
  MUKTA_MALAR: 'Mukta Malar',
  MUKTA_VAANI: 'Mukta Vaani',
  MULISH: 'Mulish',
  MURECHO: 'Murecho',
  MUSEOMODERNO: 'MuseoModerno',
  MY_SOUL: 'My Soul',
  MYNERVE: 'Mynerve',
  MYSTERY_QUEST: 'Mystery Quest',
  NTR: 'NTR',
  NABLA: 'Nabla',
  NANUM_BRUSH_SCRIPT: 'Nanum Brush Script',
  NANUM_GOTHIC: 'Nanum Gothic',
  NANUM_GOTHIC_CODING: 'Nanum Gothic Coding',
  NANUM_MYEONGJO: 'Nanum Myeongjo',
  NANUM_PEN_SCRIPT: 'Nanum Pen Script',
  NARNOOR: 'Narnoor',
  NEONDERTHAW: 'Neonderthaw',
  NERKO_ONE: 'Nerko One',
  NEUCHA: 'Neucha',
  NEUTON: 'Neuton',
  NEW_ROCKER: 'New Rocker',
  NEW_TEGOMIN: 'New Tegomin',
  NEWS_CYCLE: 'News Cycle',
  NEWSREADER: 'Newsreader',
  NICONNE: 'Niconne',
  NIRAMIT: 'Niramit',
  NIXIE_ONE: 'Nixie One',
  NOBILE: 'Nobile',
  NOKORA: 'Nokora',
  NORICAN: 'Norican',
  NOSIFER: 'Nosifer',
  NOTABLE: 'Notable',
  NOTHING_YOU_COULD_DO: 'Nothing You Could Do',
  NOTICIA_TEXT: 'Noticia Text',
  NOTO_COLOR_EMOJI: 'Noto Color Emoji',
  NOTO_EMOJI: 'Noto Emoji',
  NOTO_KUFI_ARABIC: 'Noto Kufi Arabic',
  NOTO_MUSIC: 'Noto Music',
  NOTO_NASKH_ARABIC: 'Noto Naskh Arabic',
  NOTO_NASTALIQ_URDU: 'Noto Nastaliq Urdu',
  NOTO_RASHI_HEBREW: 'Noto Rashi Hebrew',
  NOTO_SANS: 'Noto Sans',
  NOTO_SANS_ADLAM: 'Noto Sans Adlam',
  NOTO_SANS_ADLAM_UNJOINED: 'Noto Sans Adlam Unjoined',
  NOTO_SANS_ANATOLIAN_HIEROGLYPHS: 'Noto Sans Anatolian Hieroglyphs',
  NOTO_SANS_ARABIC: 'Noto Sans Arabic',
  NOTO_SANS_ARMENIAN: 'Noto Sans Armenian',
  NOTO_SANS_AVESTAN: 'Noto Sans Avestan',
  NOTO_SANS_BALINESE: 'Noto Sans Balinese',
  NOTO_SANS_BAMUM: 'Noto Sans Bamum',
  NOTO_SANS_BASSA_VAH: 'Noto Sans Bassa Vah',
  NOTO_SANS_BATAK: 'Noto Sans Batak',
  NOTO_SANS_BENGALI: 'Noto Sans Bengali',
  NOTO_SANS_BHAIKSUKI: 'Noto Sans Bhaiksuki',
  NOTO_SANS_BRAHMI: 'Noto Sans Brahmi',
  NOTO_SANS_BUGINESE: 'Noto Sans Buginese',
  NOTO_SANS_BUHID: 'Noto Sans Buhid',
  NOTO_SANS_CANADIAN_ABORIGINAL: 'Noto Sans Canadian Aboriginal',
  NOTO_SANS_CARIAN: 'Noto Sans Carian',
  NOTO_SANS_CAUCASIAN_ALBANIAN: 'Noto Sans Caucasian Albanian',
  NOTO_SANS_CHAKMA: 'Noto Sans Chakma',
  NOTO_SANS_CHAM: 'Noto Sans Cham',
  NOTO_SANS_CHEROKEE: 'Noto Sans Cherokee',
  NOTO_SANS_CHORASMIAN: 'Noto Sans Chorasmian',
  NOTO_SANS_COPTIC: 'Noto Sans Coptic',
  NOTO_SANS_CUNEIFORM: 'Noto Sans Cuneiform',
  NOTO_SANS_CYPRIOT: 'Noto Sans Cypriot',
  NOTO_SANS_CYPRO_MINOAN: 'Noto Sans Cypro Minoan',
  NOTO_SANS_DESERET: 'Noto Sans Deseret',
  NOTO_SANS_DEVANAGARI: 'Noto Sans Devanagari',
  NOTO_SANS_DISPLAY: 'Noto Sans Display',
  NOTO_SANS_DUPLOYAN: 'Noto Sans Duployan',
  NOTO_SANS_EGYPTIAN_HIEROGLYPHS: 'Noto Sans Egyptian Hieroglyphs',
  NOTO_SANS_ELBASAN: 'Noto Sans Elbasan',
  NOTO_SANS_ELYMAIC: 'Noto Sans Elymaic',
  NOTO_SANS_ETHIOPIC: 'Noto Sans Ethiopic',
  NOTO_SANS_GEORGIAN: 'Noto Sans Georgian',
  NOTO_SANS_GLAGOLITIC: 'Noto Sans Glagolitic',
  NOTO_SANS_GOTHIC: 'Noto Sans Gothic',
  NOTO_SANS_GRANTHA: 'Noto Sans Grantha',
  NOTO_SANS_GUJARATI: 'Noto Sans Gujarati',
  NOTO_SANS_GUNJALA_GONDI: 'Noto Sans Gunjala Gondi',
  NOTO_SANS_GURMUKHI: 'Noto Sans Gurmukhi',
  NOTO_SANS_HK: 'Noto Sans HK',
  NOTO_SANS_HANIFI_ROHINGYA: 'Noto Sans Hanifi Rohingya',
  NOTO_SANS_HANUNOO: 'Noto Sans Hanunoo',
  NOTO_SANS_HATRAN: 'Noto Sans Hatran',
  NOTO_SANS_HEBREW: 'Noto Sans Hebrew',
  NOTO_SANS_IMPERIAL_ARAMAIC: 'Noto Sans Imperial Aramaic',
  NOTO_SANS_INDIC_SIYAQ_NUMBERS: 'Noto Sans Indic Siyaq Numbers',
  NOTO_SANS_INSCRIPTIONAL_PAHLAVI: 'Noto Sans Inscriptional Pahlavi',
  NOTO_SANS_INSCRIPTIONAL_PARTHIAN: 'Noto Sans Inscriptional Parthian',
  NOTO_SANS_JP: 'Noto Sans JP',
  NOTO_SANS_JAVANESE: 'Noto Sans Javanese',
  NOTO_SANS_KR: 'Noto Sans KR',
  NOTO_SANS_KAITHI: 'Noto Sans Kaithi',
  NOTO_SANS_KANNADA: 'Noto Sans Kannada',
  NOTO_SANS_KAYAH_LI: 'Noto Sans Kayah Li',
  NOTO_SANS_KHAROSHTHI: 'Noto Sans Kharoshthi',
  NOTO_SANS_KHMER: 'Noto Sans Khmer',
  NOTO_SANS_KHOJKI: 'Noto Sans Khojki',
  NOTO_SANS_KHUDAWADI: 'Noto Sans Khudawadi',
  NOTO_SANS_LAO: 'Noto Sans Lao',
  NOTO_SANS_LAO_LOOPED: 'Noto Sans Lao Looped',
  NOTO_SANS_LEPCHA: 'Noto Sans Lepcha',
  NOTO_SANS_LIMBU: 'Noto Sans Limbu',
  NOTO_SANS_LINEAR_A: 'Noto Sans Linear A',
  NOTO_SANS_LINEAR_B: 'Noto Sans Linear B',
  NOTO_SANS_LISU: 'Noto Sans Lisu',
  NOTO_SANS_LYCIAN: 'Noto Sans Lycian',
  NOTO_SANS_LYDIAN: 'Noto Sans Lydian',
  NOTO_SANS_MAHAJANI: 'Noto Sans Mahajani',
  NOTO_SANS_MALAYALAM: 'Noto Sans Malayalam',
  NOTO_SANS_MANDAIC: 'Noto Sans Mandaic',
  NOTO_SANS_MANICHAEAN: 'Noto Sans Manichaean',
  NOTO_SANS_MARCHEN: 'Noto Sans Marchen',
  NOTO_SANS_MASARAM_GONDI: 'Noto Sans Masaram Gondi',
  NOTO_SANS_MATH: 'Noto Sans Math',
  NOTO_SANS_MAYAN_NUMERALS: 'Noto Sans Mayan Numerals',
  NOTO_SANS_MEDEFAIDRIN: 'Noto Sans Medefaidrin',
  NOTO_SANS_MEETEI_MAYEK: 'Noto Sans Meetei Mayek',
  NOTO_SANS_MENDE_KIKAKUI: 'Noto Sans Mende Kikakui',
  NOTO_SANS_MEROITIC: 'Noto Sans Meroitic',
  NOTO_SANS_MIAO: 'Noto Sans Miao',
  NOTO_SANS_MODI: 'Noto Sans Modi',
  NOTO_SANS_MONGOLIAN: 'Noto Sans Mongolian',
  NOTO_SANS_MONO: 'Noto Sans Mono',
  NOTO_SANS_MRO: 'Noto Sans Mro',
  NOTO_SANS_MULTANI: 'Noto Sans Multani',
  NOTO_SANS_MYANMAR: 'Noto Sans Myanmar',
  NOTO_SANS_NKO: 'Noto Sans NKo',
  NOTO_SANS_NKO_UNJOINED: 'Noto Sans NKo Unjoined',
  NOTO_SANS_NABATAEAN: 'Noto Sans Nabataean',
  NOTO_SANS_NAG_MUNDARI: 'Noto Sans Nag Mundari',
  NOTO_SANS_NANDINAGARI: 'Noto Sans Nandinagari',
  NOTO_SANS_NEW_TAI_LUE: 'Noto Sans New Tai Lue',
  NOTO_SANS_NEWA: 'Noto Sans Newa',
  NOTO_SANS_NUSHU: 'Noto Sans Nushu',
  NOTO_SANS_OGHAM: 'Noto Sans Ogham',
  NOTO_SANS_OL_CHIKI: 'Noto Sans Ol Chiki',
  NOTO_SANS_OLD_HUNGARIAN: 'Noto Sans Old Hungarian',
  NOTO_SANS_OLD_ITALIC: 'Noto Sans Old Italic',
  NOTO_SANS_OLD_NORTH_ARABIAN: 'Noto Sans Old North Arabian',
  NOTO_SANS_OLD_PERMIC: 'Noto Sans Old Permic',
  NOTO_SANS_OLD_PERSIAN: 'Noto Sans Old Persian',
  NOTO_SANS_OLD_SOGDIAN: 'Noto Sans Old Sogdian',
  NOTO_SANS_OLD_SOUTH_ARABIAN: 'Noto Sans Old South Arabian',
  NOTO_SANS_OLD_TURKIC: 'Noto Sans Old Turkic',
  NOTO_SANS_ORIYA: 'Noto Sans Oriya',
  NOTO_SANS_OSAGE: 'Noto Sans Osage',
  NOTO_SANS_OSMANYA: 'Noto Sans Osmanya',
  NOTO_SANS_PAHAWH_HMONG: 'Noto Sans Pahawh Hmong',
  NOTO_SANS_PALMYRENE: 'Noto Sans Palmyrene',
  NOTO_SANS_PAU_CIN_HAU: 'Noto Sans Pau Cin Hau',
  NOTO_SANS_PHAGS_PA: 'Noto Sans Phags Pa',
  NOTO_SANS_PHOENICIAN: 'Noto Sans Phoenician',
  NOTO_SANS_PSALTER_PAHLAVI: 'Noto Sans Psalter Pahlavi',
  NOTO_SANS_REJANG: 'Noto Sans Rejang',
  NOTO_SANS_RUNIC: 'Noto Sans Runic',
  NOTO_SANS_SC: 'Noto Sans SC',
  NOTO_SANS_SAMARITAN: 'Noto Sans Samaritan',
  NOTO_SANS_SAURASHTRA: 'Noto Sans Saurashtra',
  NOTO_SANS_SHARADA: 'Noto Sans Sharada',
  NOTO_SANS_SHAVIAN: 'Noto Sans Shavian',
  NOTO_SANS_SIDDHAM: 'Noto Sans Siddham',
  NOTO_SANS_SIGNWRITING: 'Noto Sans SignWriting',
  NOTO_SANS_SINHALA: 'Noto Sans Sinhala',
  NOTO_SANS_SOGDIAN: 'Noto Sans Sogdian',
  NOTO_SANS_SORA_SOMPENG: 'Noto Sans Sora Sompeng',
  NOTO_SANS_SOYOMBO: 'Noto Sans Soyombo',
  NOTO_SANS_SUNDANESE: 'Noto Sans Sundanese',
  NOTO_SANS_SYLOTI_NAGRI: 'Noto Sans Syloti Nagri',
  NOTO_SANS_SYMBOLS: 'Noto Sans Symbols',
  NOTO_SANS_SYMBOLS_2: 'Noto Sans Symbols 2',
  NOTO_SANS_SYRIAC: 'Noto Sans Syriac',
  NOTO_SANS_SYRIAC_EASTERN: 'Noto Sans Syriac Eastern',
  NOTO_SANS_TC: 'Noto Sans TC',
  NOTO_SANS_TAGALOG: 'Noto Sans Tagalog',
  NOTO_SANS_TAGBANWA: 'Noto Sans Tagbanwa',
  NOTO_SANS_TAI_LE: 'Noto Sans Tai Le',
  NOTO_SANS_TAI_THAM: 'Noto Sans Tai Tham',
  NOTO_SANS_TAI_VIET: 'Noto Sans Tai Viet',
  NOTO_SANS_TAKRI: 'Noto Sans Takri',
  NOTO_SANS_TAMIL: 'Noto Sans Tamil',
  NOTO_SANS_TAMIL_SUPPLEMENT: 'Noto Sans Tamil Supplement',
  NOTO_SANS_TANGSA: 'Noto Sans Tangsa',
  NOTO_SANS_TELUGU: 'Noto Sans Telugu',
  NOTO_SANS_THAANA: 'Noto Sans Thaana',
  NOTO_SANS_THAI: 'Noto Sans Thai',
  NOTO_SANS_THAI_LOOPED: 'Noto Sans Thai Looped',
  NOTO_SANS_TIFINAGH: 'Noto Sans Tifinagh',
  NOTO_SANS_TIRHUTA: 'Noto Sans Tirhuta',
  NOTO_SANS_UGARITIC: 'Noto Sans Ugaritic',
  NOTO_SANS_VAI: 'Noto Sans Vai',
  NOTO_SANS_VITHKUQI: 'Noto Sans Vithkuqi',
  NOTO_SANS_WANCHO: 'Noto Sans Wancho',
  NOTO_SANS_WARANG_CITI: 'Noto Sans Warang Citi',
  NOTO_SANS_YI: 'Noto Sans Yi',
  NOTO_SANS_ZANABAZAR_SQUARE: 'Noto Sans Zanabazar Square',
  NOTO_SERIF: 'Noto Serif',
  NOTO_SERIF_AHOM: 'Noto Serif Ahom',
  NOTO_SERIF_ARMENIAN: 'Noto Serif Armenian',
  NOTO_SERIF_BALINESE: 'Noto Serif Balinese',
  NOTO_SERIF_BENGALI: 'Noto Serif Bengali',
  NOTO_SERIF_DEVANAGARI: 'Noto Serif Devanagari',
  NOTO_SERIF_DISPLAY: 'Noto Serif Display',
  NOTO_SERIF_DOGRA: 'Noto Serif Dogra',
  NOTO_SERIF_ETHIOPIC: 'Noto Serif Ethiopic',
  NOTO_SERIF_GEORGIAN: 'Noto Serif Georgian',
  NOTO_SERIF_GRANTHA: 'Noto Serif Grantha',
  NOTO_SERIF_GUJARATI: 'Noto Serif Gujarati',
  NOTO_SERIF_GURMUKHI: 'Noto Serif Gurmukhi',
  NOTO_SERIF_HK: 'Noto Serif HK',
  NOTO_SERIF_HEBREW: 'Noto Serif Hebrew',
  NOTO_SERIF_JP: 'Noto Serif JP',
  NOTO_SERIF_KR: 'Noto Serif KR',
  NOTO_SERIF_KANNADA: 'Noto Serif Kannada',
  NOTO_SERIF_KHITAN_SMALL_SCRIPT: 'Noto Serif Khitan Small Script',
  NOTO_SERIF_KHMER: 'Noto Serif Khmer',
  NOTO_SERIF_KHOJKI: 'Noto Serif Khojki',
  NOTO_SERIF_LAO: 'Noto Serif Lao',
  NOTO_SERIF_MAKASAR: 'Noto Serif Makasar',
  NOTO_SERIF_MALAYALAM: 'Noto Serif Malayalam',
  NOTO_SERIF_MYANMAR: 'Noto Serif Myanmar',
  NOTO_SERIF_NP_HMONG: 'Noto Serif NP Hmong',
  NOTO_SERIF_ORIYA: 'Noto Serif Oriya',
  NOTO_SERIF_OTTOMAN_SIYAQ: 'Noto Serif Ottoman Siyaq',
  NOTO_SERIF_SC: 'Noto Serif SC',
  NOTO_SERIF_SINHALA: 'Noto Serif Sinhala',
  NOTO_SERIF_TC: 'Noto Serif TC',
  NOTO_SERIF_TAMIL: 'Noto Serif Tamil',
  NOTO_SERIF_TANGUT: 'Noto Serif Tangut',
  NOTO_SERIF_TELUGU: 'Noto Serif Telugu',
  NOTO_SERIF_THAI: 'Noto Serif Thai',
  NOTO_SERIF_TIBETAN: 'Noto Serif Tibetan',
  NOTO_SERIF_TOTO: 'Noto Serif Toto',
  NOTO_SERIF_VITHKUQI: 'Noto Serif Vithkuqi',
  NOTO_SERIF_YEZIDI: 'Noto Serif Yezidi',
  NOTO_TRADITIONAL_NUSHU: 'Noto Traditional Nushu',
  NOVA_CUT: 'Nova Cut',
  NOVA_FLAT: 'Nova Flat',
  NOVA_MONO: 'Nova Mono',
  NOVA_OVAL: 'Nova Oval',
  NOVA_ROUND: 'Nova Round',
  NOVA_SCRIPT: 'Nova Script',
  NOVA_SLIM: 'Nova Slim',
  NOVA_SQUARE: 'Nova Square',
  NUMANS: 'Numans',
  NUNITO: 'Nunito',
  NUNITO_SANS: 'Nunito Sans',
  NUOSU_SIL: 'Nuosu SIL',
  ODIBEE_SANS: 'Odibee Sans',
  ODOR_MEAN_CHEY: 'Odor Mean Chey',
  OFFSIDE: 'Offside',
  OI: 'Oi',
  OLD_STANDARD_TT: 'Old Standard TT',
  OLDENBURG: 'Oldenburg',
  OLE: 'Ole',
  OLEO_SCRIPT: 'Oleo Script',
  OLEO_SCRIPT_SWASH_CAPS: 'Oleo Script Swash Caps',
  ONEST: 'Onest',
  OOOH_BABY: 'Oooh Baby',
  OPEN_SANS: 'Open Sans',
  ORANIENBAUM: 'Oranienbaum',
  ORBIT: 'Orbit',
  ORBITRON: 'Orbitron',
  OREGANO: 'Oregano',
  ORELEGA_ONE: 'Orelega One',
  ORIENTA: 'Orienta',
  ORIGINAL_SURFER: 'Original Surfer',
  OSWALD: 'Oswald',
  OUTFIT: 'Outfit',
  OVER_THE_RAINBOW: 'Over the Rainbow',
  OVERLOCK: 'Overlock',
  OVERLOCK_SC: 'Overlock SC',
  OVERPASS: 'Overpass',
  OVERPASS_MONO: 'Overpass Mono',
  OVO: 'Ovo',
  OXANIUM: 'Oxanium',
  OXYGEN: 'Oxygen',
  OXYGEN_MONO: 'Oxygen Mono',
  PT_MONO: 'PT Mono',
  PT_SANS: 'PT Sans',
  PT_SANS_CAPTION: 'PT Sans Caption',
  PT_SANS_NARROW: 'PT Sans Narrow',
  PT_SERIF: 'PT Serif',
  PT_SERIF_CAPTION: 'PT Serif Caption',
  PACIFICO: 'Pacifico',
  PADAUK: 'Padauk',
  PADYAKKE_EXPANDED_ONE: 'Padyakke Expanded One',
  PALANQUIN: 'Palanquin',
  PALANQUIN_DARK: 'Palanquin Dark',
  PALETTE_MOSAIC: 'Palette Mosaic',
  PANGOLIN: 'Pangolin',
  PAPRIKA: 'Paprika',
  PARISIENNE: 'Parisienne',
  PASSERO_ONE: 'Passero One',
  PASSION_ONE: 'Passion One',
  PASSIONS_CONFLICT: 'Passions Conflict',
  PATHWAY_EXTREME: 'Pathway Extreme',
  PATHWAY_GOTHIC_ONE: 'Pathway Gothic One',
  PATRICK_HAND: 'Patrick Hand',
  PATRICK_HAND_SC: 'Patrick Hand SC',
  PATTAYA: 'Pattaya',
  PATUA_ONE: 'Patua One',
  PAVANAM: 'Pavanam',
  PAYTONE_ONE: 'Paytone One',
  PEDDANA: 'Peddana',
  PERALTA: 'Peralta',
  PERMANENT_MARKER: 'Permanent Marker',
  PETEMOSS: 'Petemoss',
  PETIT_FORMAL_SCRIPT: 'Petit Formal Script',
  PETRONA: 'Petrona',
  PHILOSOPHER: 'Philosopher',
  PHUDU: 'Phudu',
  PIAZZOLLA: 'Piazzolla',
  PIEDRA: 'Piedra',
  PINYON_SCRIPT: 'Pinyon Script',
  PIRATA_ONE: 'Pirata One',
  PIXELIFY_SANS: 'Pixelify Sans',
  PLASTER: 'Plaster',
  PLAY: 'Play',
  PLAYBALL: 'Playball',
  PLAYFAIR: 'Playfair',
  PLAYFAIR_DISPLAY: 'Playfair Display',
  PLAYFAIR_DISPLAY_SC: 'Playfair Display SC',
  PLAYPEN_SANS: 'Playpen Sans',
  PLUS_JAKARTA_SANS: 'Plus Jakarta Sans',
  PODKOVA: 'Podkova',
  POIRET_ONE: 'Poiret One',
  POLLER_ONE: 'Poller One',
  POLTAWSKI_NOWY: 'Poltawski Nowy',
  POLY: 'Poly',
  POMPIERE: 'Pompiere',
  PONTANO_SANS: 'Pontano Sans',
  POOR_STORY: 'Poor Story',
  POPPINS: 'Poppins',
  PORT_LLIGAT_SANS: 'Port Lligat Sans',
  PORT_LLIGAT_SLAB: 'Port Lligat Slab',
  POTTA_ONE: 'Potta One',
  PRAGATI_NARROW: 'Pragati Narrow',
  PRAISE: 'Praise',
  PRATA: 'Prata',
  PREAHVIHEAR: 'Preahvihear',
  PRESS_START_2P: 'Press Start 2P',
  PRIDI: 'Pridi',
  PRINCESS_SOFIA: 'Princess Sofia',
  PROCIONO: 'Prociono',
  PROMPT: 'Prompt',
  PROSTO_ONE: 'Prosto One',
  PROZA_LIBRE: 'Proza Libre',
  PUBLIC_SANS: 'Public Sans',
  PUPPIES_PLAY: 'Puppies Play',
  PURITAN: 'Puritan',
  PURPLE_PURSE: 'Purple Purse',
  QAHIRI: 'Qahiri',
  QUANDO: 'Quando',
  QUANTICO: 'Quantico',
  QUATTROCENTO: 'Quattrocento',
  QUATTROCENTO_SANS: 'Quattrocento Sans',
  QUESTRIAL: 'Questrial',
  QUICKSAND: 'Quicksand',
  QUINTESSENTIAL: 'Quintessential',
  QWIGLEY: 'Qwigley',
  QWITCHER_GRYPEN: 'Qwitcher Grypen',
  REM: 'REM',
  RACING_SANS_ONE: 'Racing Sans One',
  RADIO_CANADA: 'Radio Canada',
  RADLEY: 'Radley',
  RAJDHANI: 'Rajdhani',
  RAKKAS: 'Rakkas',
  RALEWAY: 'Raleway',
  RALEWAY_DOTS: 'Raleway Dots',
  RAMABHADRA: 'Ramabhadra',
  RAMARAJA: 'Ramaraja',
  RAMBLA: 'Rambla',
  RAMMETTO_ONE: 'Rammetto One',
  RAMPART_ONE: 'Rampart One',
  RANCHERS: 'Ranchers',
  RANCHO: 'Rancho',
  RANGA: 'Ranga',
  RASA: 'Rasa',
  RATIONALE: 'Rationale',
  RAVI_PRAKASH: 'Ravi Prakash',
  READEX_PRO: 'Readex Pro',
  RECURSIVE: 'Recursive',
  RED_HAT_DISPLAY: 'Red Hat Display',
  RED_HAT_MONO: 'Red Hat Mono',
  RED_HAT_TEXT: 'Red Hat Text',
  RED_ROSE: 'Red Rose',
  REDACTED: 'Redacted',
  REDACTED_SCRIPT: 'Redacted Script',
  REDRESSED: 'Redressed',
  REEM_KUFI: 'Reem Kufi',
  REEM_KUFI_FUN: 'Reem Kufi Fun',
  REEM_KUFI_INK: 'Reem Kufi Ink',
  REENIE_BEANIE: 'Reenie Beanie',
  REGGAE_ONE: 'Reggae One',
  REVALIA: 'Revalia',
  RHODIUM_LIBRE: 'Rhodium Libre',
  RIBEYE: 'Ribeye',
  RIBEYE_MARROW: 'Ribeye Marrow',
  RIGHTEOUS: 'Righteous',
  RISQUE: 'Risque',
  ROAD_RAGE: 'Road Rage',
  ROBOTO: 'Roboto',
  ROBOTO_CONDENSED: 'Roboto Condensed',
  ROBOTO_FLEX: 'Roboto Flex',
  ROBOTO_MONO: 'Roboto Mono',
  ROBOTO_SERIF: 'Roboto Serif',
  ROBOTO_SLAB: 'Roboto Slab',
  ROCHESTER: 'Rochester',
  ROCK_3D: 'Rock 3D',
  ROCK_SALT: 'Rock Salt',
  ROCKNROLL_ONE: 'RocknRoll One',
  ROKKITT: 'Rokkitt',
  ROMANESCO: 'Romanesco',
  ROPA_SANS: 'Ropa Sans',
  ROSARIO: 'Rosario',
  ROSARIVO: 'Rosarivo',
  ROUGE_SCRIPT: 'Rouge Script',
  ROWDIES: 'Rowdies',
  ROZHA_ONE: 'Rozha One',
  RUBIK: 'Rubik',
  RUBIK_80S_FADE: 'Rubik 80s Fade',
  RUBIK_BEASTLY: 'Rubik Beastly',
  RUBIK_BUBBLES: 'Rubik Bubbles',
  RUBIK_BURNED: 'Rubik Burned',
  RUBIK_DIRT: 'Rubik Dirt',
  RUBIK_DISTRESSED: 'Rubik Distressed',
  RUBIK_GEMSTONES: 'Rubik Gemstones',
  RUBIK_GLITCH: 'Rubik Glitch',
  RUBIK_ISO: 'Rubik Iso',
  RUBIK_MARKER_HATCH: 'Rubik Marker Hatch',
  RUBIK_MAZE: 'Rubik Maze',
  RUBIK_MICROBE: 'Rubik Microbe',
  RUBIK_MONO_ONE: 'Rubik Mono One',
  RUBIK_MOONROCKS: 'Rubik Moonrocks',
  RUBIK_PIXELS: 'Rubik Pixels',
  RUBIK_PUDDLES: 'Rubik Puddles',
  RUBIK_SPRAY_PAINT: 'Rubik Spray Paint',
  RUBIK_STORM: 'Rubik Storm',
  RUBIK_VINYL: 'Rubik Vinyl',
  RUBIK_WET_PAINT: 'Rubik Wet Paint',
  RUDA: 'Ruda',
  RUFINA: 'Rufina',
  RUGE_BOOGIE: 'Ruge Boogie',
  RULUKO: 'Ruluko',
  RUM_RAISIN: 'Rum Raisin',
  RUSLAN_DISPLAY: 'Ruslan Display',
  RUSSO_ONE: 'Russo One',
  RUTHIE: 'Ruthie',
  RUWUDU: 'Ruwudu',
  RYE: 'Rye',
  STIX_TWO_TEXT: 'STIX Two Text',
  SACRAMENTO: 'Sacramento',
  SAHITYA: 'Sahitya',
  SAIL: 'Sail',
  SAIRA: 'Saira',
  SAIRA_CONDENSED: 'Saira Condensed',
  SAIRA_EXTRA_CONDENSED: 'Saira Extra Condensed',
  SAIRA_SEMI_CONDENSED: 'Saira Semi Condensed',
  SAIRA_STENCIL_ONE: 'Saira Stencil One',
  SALSA: 'Salsa',
  SANCHEZ: 'Sanchez',
  SANCREEK: 'Sancreek',
  SANSITA: 'Sansita',
  SANSITA_SWASHED: 'Sansita Swashed',
  SARABUN: 'Sarabun',
  SARALA: 'Sarala',
  SARINA: 'Sarina',
  SARPANCH: 'Sarpanch',
  SASSY_FRASS: 'Sassy Frass',
  SATISFY: 'Satisfy',
  SAWARABI_GOTHIC: 'Sawarabi Gothic',
  SAWARABI_MINCHO: 'Sawarabi Mincho',
  SCADA: 'Scada',
  SCHEHERAZADE_NEW: 'Scheherazade New',
  SCHIBSTED_GROTESK: 'Schibsted Grotesk',
  SCHOOLBELL: 'Schoolbell',
  SCOPE_ONE: 'Scope One',
  SEAWEED_SCRIPT: 'Seaweed Script',
  SECULAR_ONE: 'Secular One',
  SEDGWICK_AVE: 'Sedgwick Ave',
  SEDGWICK_AVE_DISPLAY: 'Sedgwick Ave Display',
  SEN: 'Sen',
  SEND_FLOWERS: 'Send Flowers',
  SEVILLANA: 'Sevillana',
  SEYMOUR_ONE: 'Seymour One',
  SHADOWS_INTO_LIGHT: 'Shadows Into Light',
  SHADOWS_INTO_LIGHT_TWO: 'Shadows Into Light Two',
  SHALIMAR: 'Shalimar',
  SHANTELL_SANS: 'Shantell Sans',
  SHANTI: 'Shanti',
  SHARE: 'Share',
  SHARE_TECH: 'Share Tech',
  SHARE_TECH_MONO: 'Share Tech Mono',
  SHIPPORI_ANTIQUE: 'Shippori Antique',
  SHIPPORI_ANTIQUE_B1: 'Shippori Antique B1',
  SHIPPORI_MINCHO: 'Shippori Mincho',
  SHIPPORI_MINCHO_B1: 'Shippori Mincho B1',
  SHIZURU: 'Shizuru',
  SHOJUMARU: 'Shojumaru',
  SHORT_STACK: 'Short Stack',
  SHRIKHAND: 'Shrikhand',
  SIEMREAP: 'Siemreap',
  SIGMAR: 'Sigmar',
  SIGMAR_ONE: 'Sigmar One',
  SIGNIKA: 'Signika',
  SIGNIKA_NEGATIVE: 'Signika Negative',
  SILKSCREEN: 'Silkscreen',
  SIMONETTA: 'Simonetta',
  SINGLE_DAY: 'Single Day',
  SINTONY: 'Sintony',
  SIRIN_STENCIL: 'Sirin Stencil',
  SIX_CAPS: 'Six Caps',
  SKRANJI: 'Skranji',
  SLABO_13PX: 'Slabo 13px',
  SLABO_27PX: 'Slabo 27px',
  SLACKEY: 'Slackey',
  SLACKSIDE_ONE: 'Slackside One',
  SMOKUM: 'Smokum',
  SMOOCH: 'Smooch',
  SMOOCH_SANS: 'Smooch Sans',
  SMYTHE: 'Smythe',
  SNIGLET: 'Sniglet',
  SNIPPET: 'Snippet',
  SNOWBURST_ONE: 'Snowburst One',
  SOFADI_ONE: 'Sofadi One',
  SOFIA: 'Sofia',
  SOFIA_SANS: 'Sofia Sans',
  SOFIA_SANS_CONDENSED: 'Sofia Sans Condensed',
  SOFIA_SANS_EXTRA_CONDENSED: 'Sofia Sans Extra Condensed',
  SOFIA_SANS_SEMI_CONDENSED: 'Sofia Sans Semi Condensed',
  SOLITREO: 'Solitreo',
  SOLWAY: 'Solway',
  SOMETYPE_MONO: 'Sometype Mono',
  SONG_MYUNG: 'Song Myung',
  SONO: 'Sono',
  SONSIE_ONE: 'Sonsie One',
  SORA: 'Sora',
  SORTS_MILL_GOUDY: 'Sorts Mill Goudy',
  SOURCE_CODE_PRO: 'Source Code Pro',
  SOURCE_SANS_3: 'Source Sans 3',
  SOURCE_SERIF_4: 'Source Serif 4',
  SPACE_GROTESK: 'Space Grotesk',
  SPACE_MONO: 'Space Mono',
  SPECIAL_ELITE: 'Special Elite',
  SPECTRAL: 'Spectral',
  SPECTRAL_SC: 'Spectral SC',
  SPICY_RICE: 'Spicy Rice',
  SPINNAKER: 'Spinnaker',
  SPIRAX: 'Spirax',
  SPLASH: 'Splash',
  SPLINE_SANS: 'Spline Sans',
  SPLINE_SANS_MONO: 'Spline Sans Mono',
  SQUADA_ONE: 'Squada One',
  SQUARE_PEG: 'Square Peg',
  SREE_KRUSHNADEVARAYA: 'Sree Krushnadevaraya',
  SRIRACHA: 'Sriracha',
  SRISAKDI: 'Srisakdi',
  STAATLICHES: 'Staatliches',
  STALEMATE: 'Stalemate',
  STALINIST_ONE: 'Stalinist One',
  STARDOS_STENCIL: 'Stardos Stencil',
  STICK: 'Stick',
  STICK_NO_BILLS: 'Stick No Bills',
  STINT_ULTRA_CONDENSED: 'Stint Ultra Condensed',
  STINT_ULTRA_EXPANDED: 'Stint Ultra Expanded',
  STOKE: 'Stoke',
  STRAIT: 'Strait',
  STYLE_SCRIPT: 'Style Script',
  STYLISH: 'Stylish',
  SUE_ELLEN_FRANCISCO: 'Sue Ellen Francisco',
  SUEZ_ONE: 'Suez One',
  SULPHUR_POINT: 'Sulphur Point',
  SUMANA: 'Sumana',
  SUNFLOWER: 'Sunflower',
  SUNSHINEY: 'Sunshiney',
  SUPERMERCADO_ONE: 'Supermercado One',
  SURA: 'Sura',
  SURANNA: 'Suranna',
  SURAVARAM: 'Suravaram',
  SUWANNAPHUM: 'Suwannaphum',
  SWANKY_AND_MOO_MOO: 'Swanky and Moo Moo',
  SYNCOPATE: 'Syncopate',
  SYNE: 'Syne',
  SYNE_MONO: 'Syne Mono',
  SYNE_TACTILE: 'Syne Tactile',
  TAI_HERITAGE_PRO: 'Tai Heritage Pro',
  TAJAWAL: 'Tajawal',
  TANGERINE: 'Tangerine',
  TAPESTRY: 'Tapestry',
  TAPROM: 'Taprom',
  TAURI: 'Tauri',
  TAVIRAJ: 'Taviraj',
  TEKO: 'Teko',
  TEKTUR: 'Tektur',
  TELEX: 'Telex',
  TENALI_RAMAKRISHNA: 'Tenali Ramakrishna',
  TENOR_SANS: 'Tenor Sans',
  TEXT_ME_ONE: 'Text Me One',
  TEXTURINA: 'Texturina',
  THASADITH: 'Thasadith',
  THE_GIRL_NEXT_DOOR: 'The Girl Next Door',
  THE_NAUTIGAL: 'The Nautigal',
  TIENNE: 'Tienne',
  TILLANA: 'Tillana',
  TILT_NEON: 'Tilt Neon',
  TILT_PRISM: 'Tilt Prism',
  TILT_WARP: 'Tilt Warp',
  TIMMANA: 'Timmana',
  TINOS: 'Tinos',
  TIRO_BANGLA: 'Tiro Bangla',
  TIRO_DEVANAGARI_HINDI: 'Tiro Devanagari Hindi',
  TIRO_DEVANAGARI_MARATHI: 'Tiro Devanagari Marathi',
  TIRO_DEVANAGARI_SANSKRIT: 'Tiro Devanagari Sanskrit',
  TIRO_GURMUKHI: 'Tiro Gurmukhi',
  TIRO_KANNADA: 'Tiro Kannada',
  TIRO_TAMIL: 'Tiro Tamil',
  TIRO_TELUGU: 'Tiro Telugu',
  TITAN_ONE: 'Titan One',
  TITILLIUM_WEB: 'Titillium Web',
  TOMORROW: 'Tomorrow',
  TOURNEY: 'Tourney',
  TRADE_WINDS: 'Trade Winds',
  TRAIN_ONE: 'Train One',
  TRIRONG: 'Trirong',
  TRISPACE: 'Trispace',
  TROCCHI: 'Trocchi',
  TROCHUT: 'Trochut',
  TRUCULENTA: 'Truculenta',
  TRYKKER: 'Trykker',
  TSUKIMI_ROUNDED: 'Tsukimi Rounded',
  TULPEN_ONE: 'Tulpen One',
  TURRET_ROAD: 'Turret Road',
  TWINKLE_STAR: 'Twinkle Star',
  UBUNTU: 'Ubuntu',
  UBUNTU_CONDENSED: 'Ubuntu Condensed',
  UBUNTU_MONO: 'Ubuntu Mono',
  UCHEN: 'Uchen',
  ULTRA: 'Ultra',
  UNBOUNDED: 'Unbounded',
  UNCIAL_ANTIQUA: 'Uncial Antiqua',
  UNDERDOG: 'Underdog',
  UNICA_ONE: 'Unica One',
  UNIFRAKTURCOOK: 'UnifrakturCook',
  UNIFRAKTURMAGUNTIA: 'UnifrakturMaguntia',
  UNKEMPT: 'Unkempt',
  UNLOCK: 'Unlock',
  UNNA: 'Unna',
  UPDOCK: 'Updock',
  URBANIST: 'Urbanist',
  VT323: 'VT323',
  VAMPIRO_ONE: 'Vampiro One',
  VARELA: 'Varela',
  VARELA_ROUND: 'Varela Round',
  VARTA: 'Varta',
  VAST_SHADOW: 'Vast Shadow',
  VAZIRMATN: 'Vazirmatn',
  VESPER_LIBRE: 'Vesper Libre',
  VIAODA_LIBRE: 'Viaoda Libre',
  VIBES: 'Vibes',
  VIBUR: 'Vibur',
  VICTOR_MONO: 'Victor Mono',
  VIDALOKA: 'Vidaloka',
  VIGA: 'Viga',
  VINA_SANS: 'Vina Sans',
  VOCES: 'Voces',
  VOLKHOV: 'Volkhov',
  VOLLKORN: 'Vollkorn',
  VOLLKORN_SC: 'Vollkorn SC',
  VOLTAIRE: 'Voltaire',
  VUJAHDAY_SCRIPT: 'Vujahday Script',
  WAITING_FOR_THE_SUNRISE: 'Waiting for the Sunrise',
  WALLPOET: 'Wallpoet',
  WALTER_TURNCOAT: 'Walter Turncoat',
  WARNES: 'Warnes',
  WATER_BRUSH: 'Water Brush',
  WATERFALL: 'Waterfall',
  WAVEFONT: 'Wavefont',
  WELLFLEET: 'Wellfleet',
  WENDY_ONE: 'Wendy One',
  WHISPER: 'Whisper',
  WINDSONG: 'WindSong',
  WIRE_ONE: 'Wire One',
  WIX_MADEFOR_DISPLAY: 'Wix Madefor Display',
  WIX_MADEFOR_TEXT: 'Wix Madefor Text',
  WORK_SANS: 'Work Sans',
  XANH_MONO: 'Xanh Mono',
  YALDEVI: 'Yaldevi',
  YANONE_KAFFEESATZ: 'Yanone Kaffeesatz',
  YANTRAMANAV: 'Yantramanav',
  YATRA_ONE: 'Yatra One',
  YELLOWTAIL: 'Yellowtail',
  YEON_SUNG: 'Yeon Sung',
  YESEVA_ONE: 'Yeseva One',
  YESTERYEAR: 'Yesteryear',
  YOMOGI: 'Yomogi',
  YOUNG_SERIF: 'Young Serif',
  YRSA: 'Yrsa',
  YSABEAU: 'Ysabeau',
  YSABEAU_INFANT: 'Ysabeau Infant',
  YSABEAU_OFFICE: 'Ysabeau Office',
  YSABEAU_SC: 'Ysabeau SC',
  YUJI_BOKU: 'Yuji Boku',
  YUJI_HENTAIGANA_AKARI: 'Yuji Hentaigana Akari',
  YUJI_HENTAIGANA_AKEBONO: 'Yuji Hentaigana Akebono',
  YUJI_MAI: 'Yuji Mai',
  YUJI_SYUKU: 'Yuji Syuku',
  YUSEI_MAGIC: 'Yusei Magic',
  ZCOOL_KUAILE: 'ZCOOL KuaiLe',
  ZCOOL_QINGKE_HUANGYOU: 'ZCOOL QingKe HuangYou',
  ZCOOL_XIAOWEI: 'ZCOOL XiaoWei',
  ZEN_ANTIQUE: 'Zen Antique',
  ZEN_ANTIQUE_SOFT: 'Zen Antique Soft',
  ZEN_DOTS: 'Zen Dots',
  ZEN_KAKU_GOTHIC_ANTIQUE: 'Zen Kaku Gothic Antique',
  ZEN_KAKU_GOTHIC_NEW: 'Zen Kaku Gothic New',
  ZEN_KURENAIDO: 'Zen Kurenaido',
  ZEN_LOOP: 'Zen Loop',
  ZEN_MARU_GOTHIC: 'Zen Maru Gothic',
  ZEN_OLD_MINCHO: 'Zen Old Mincho',
  ZEN_TOKYO_ZOO: 'Zen Tokyo Zoo',
  ZEYADA: 'Zeyada',
  ZHI_MANG_XING: 'Zhi Mang Xing',
  ZILLA_SLAB: 'Zilla Slab',
  ZILLA_SLAB_HIGHLIGHT: 'Zilla Slab Highlight',
};

export default WebFontsEnum;
